var _VALIDATORS;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export var ERROR = 'not_valid_personal_id';
import personalIdLithuania from './personalId/personalIdLithuania';
import personalIdLatvia from './personalId/personalIdLatvia';
var COUNTRIES = {
  LT: 'lt',
  LV: 'lv'
};
var VALIDATORS = (_VALIDATORS = {}, _defineProperty(_VALIDATORS, COUNTRIES.LT, personalIdLithuania), _defineProperty(_VALIDATORS, COUNTRIES.LV, personalIdLatvia), _VALIDATORS);
var personalId = function personalId(country) {
  if (!country) {
    throw Error('Country ID must be provided');
  }
  return VALIDATORS[country]();
};
personalId.COUNTRIES = COUNTRIES;
export default personalId;